var exports = {
  "container": "x43cbe9c2--7bcebf--container",
};

module.exports = exports;
